import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={46}
            height={46}
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x={3} y={3} width={40} height={40} rx={20} fill={theme["#B4E3E1"]} />
            <path
                d="M23 21.75v-2.917m0 5.834h.008M21.25 29l1.217 1.622c.18.241.271.362.382.405a.416.416 0 00.302 0c.11-.043.201-.164.382-.405L24.75 29c.244-.326.366-.489.515-.613.2-.166.434-.283.685-.342.19-.045.393-.045.8-.045 1.165 0 1.747 0 2.207-.19a2.5 2.5 0 001.353-1.353c.19-.46.19-1.042.19-2.207V19.5c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 00-1.092-1.092C28.6 15.5 27.9 15.5 26.5 15.5h-7c-1.4 0-2.1 0-2.635.273a2.5 2.5 0 00-1.092 1.092C15.5 17.4 15.5 18.1 15.5 19.5v4.75c0 1.165 0 1.747.19 2.207a2.5 2.5 0 001.353 1.353c.46.19 1.042.19 2.207.19.407 0 .61 0 .8.045.251.059.486.176.685.342.149.124.27.287.515.613z"
                stroke={theme["#0D968F"]}
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x={3}
                y={3}
                width={40}
                height={40}
                rx={20}
                stroke={theme["#E7F6F5"]}
                strokeWidth={6}
            />
        </svg>
    )
}
  
  export default SvgComponent